<template>
  <v-card flat class="px-3">
    <form
      ref="downloadForm"
      method="post"
      :action="customDownloadUrl || downloadUrl"
      style="display: none"
    >
      <input
        ref="downloadInput"
        name="Authorization"
        :value="authToken"
        type="hidden"
      />
    </form>

    <v-col cols="12" class="body-bold-smaller py-0">
      <a type="primary" size="xsmall" @click="handleBack">
        <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
        {{ $t('message.actions.return') }}
      </a>
    </v-col>

    <v-col cols="12" class="pt-1 py-0">
      <span class="body-bold-medium" style="vertical-align: middle">
        {{ $t('message.pages.video.qualities') }}
      </span>
    </v-col>

    <v-col cols="12" class="py-0">
      <span class="body-regular-smaller textType6--text pageDescription">
        {{ $t('message.pages.video.qualitiesMessage') }}
        <a
          target="_blank"
          type="secondary"
          :href="$t('message.pages.video.qualitiesMessageUrl')"
        >
          <span>
            {{ $t('message.pages.video.learnMoreHere') }}
          </span>
          <v-icon size="12">mdi-open-in-new</v-icon>
        </a>
      </span>
    </v-col>

    <v-col v-if="loadings.fetch" cols="12">
      <v-row align="center" class="mt-5" justify="center">
        <v-progress-circular
          indeterminate
          color="primary"
          class="mb-4"
        ></v-progress-circular>
      </v-row>
    </v-col>
    <v-col cols="12" v-else class="px-0 list-storage-video">
      <v-card flat>
        <v-col cols="12" class="pt-1 py-0 mt-8">
          <span class="body-bold-medium" style="vertical-align: middle">
            {{ $t('message.pages.video.available') }}
          </span>
        </v-col>

        <v-col
          cols="12"
          v-for="(storageItem, index) in sizesComputed"
          :key="`${storageItem.name}--${index}`"
          class="mt-2 mb-2"
        >
          <v-col>
            <v-row
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
              class="d-flex"
            >
              <div style="display: grid">
                <span
                  class="body-regular-medium neutral-20-dark--text"
                  style="font-size: 14px"
                  >{{ storageItem.name }}</span
                >
                <span
                  class="body-regular-smaller neutral-40-light--text"
                  style="font-size: 12px"
                  v-if="storageItem.value"
                  >{{
                    addDecimal(
                      calcMegabytes(storageItem.value, 'B', 'MB', true)
                    )
                  }}</span
                >
              </div>
              <quality-status
                v-if="qualitysWithError(storageItem.name)"
                :status="'error'"
                :isQualityScreen="true"
                style="display: flex; margin-left: auto"
              ></quality-status>
              <v-tag
                v-else-if="storageItem.disabled"
                type="neutral"
                style="display: flex; margin-left: auto"
                >{{ $t('message.pages.video.disabled') }}
              </v-tag>

              <v-tag
                v-else-if="initQuality === storageItem.name"
                type="default"
                style="display: flex; margin-left: auto"
                >{{ $t('message.pages.video.initQuality') }}
              </v-tag>

              <v-menu
                offset-y
                bottom
                left
                :close-on-content-click="false"
                class="ml-2"
                min-width="200px"
                v-if="!qualitysWithError(storageItem.name)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <base-btn
                    color="neutral-light"
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                    icon
                    type="neutral"
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      font-size: 16px;
                      padding: 0 !important;
                      width: 30px !important;
                      height: 30px !important;
                    "
                  >
                    <v-icon
                      :color="
                        $vuetify.theme.dark
                          ? 'var(--neutral-40-light-dark)'
                          : 'var(--neutral-40-light-light)'
                      "
                      size="16px"
                      >mdi-dots-vertical</v-icon
                    >
                  </base-btn>
                </template>
                <v-list class="list__subtitle-actions">
                  <v-tooltip v-if="!isSubscriptionEnabledToDownload" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-list-item
                          @click="handleDownloadQuality(storageItem)"
                          :disabled="!isSubscriptionEnabledToDownload || !hasEditVideoPerm"
                          style="cursor: pointer"
                        >
                          <v-list-item-action v-if="loadings.download">
                            <v-progress-circular
                              indeterminate
                              color="primary"
                              size="24"
                            />
                          </v-list-item-action>
                          <v-list-item-title v-else>
                            <span class="body-regular-smaller">
                              {{ $t('message.pages.video.download') }}
                            </span>
                          </v-list-item-title>
                        </v-list-item>
                      </span>
                    </template>
                    <span>{{
                      $t('message.downloadVideoModal.disabledDownload')
                    }}</span>
                  </v-tooltip>
                  <v-list-item
                    v-else
                    :disabled="!hasEditVideoPerm"
                    @click="handleDownloadQuality(storageItem)"
                    style="cursor: pointer"
                  >
                    <v-list-item-action v-if="loadings.download">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        size="24"
                      />
                    </v-list-item-action>
                    <v-list-item-title v-else>
                      <span class="body-regular-smaller">
                        {{ $t('message.pages.video.download') }}
                      </span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="
                      handleShowModal(storageItem.name, !storageItem.disabled)
                    "
                    :disabled="!hasEditVideoPerm"
                    style="cursor: pointer"
                  >
                    <v-list-item-action v-if="loadings.disableQuality">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        size="24"
                      />
                    </v-list-item-action>
                    <v-list-item-title v-else>
                      <span class="body-regular-smaller">
                        {{
                          $t(
                            `message.pages.video.${
                              storageItem.disabled
                                ? 'enableQuality'
                                : 'disableQuality'
                            }`
                          )
                        }}
                      </span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    :disabled="!hasEditVideoPerm"
                    @click="handleSelectInitQuality(storageItem.name)"
                    style="cursor: pointer"
                  >
                    <v-list-item-action v-if="loadings.startQuality">
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        size="24"
                      />
                    </v-list-item-action>
                    <v-list-item-title v-else>
                      <span class="body-regular-smaller">
                        {{ $t('message.pages.video.startWithQuality') }}
                      </span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on, attrs }">
                  <base-btn
                    v-bind="attrs"
                    v-on="on"
                    style="
                      width: 28px;
                      height: 24px;
                      padding: 10px;
                      padding-top: 16px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      margin-left: 16px;
                    "
                    @click="handleReencodeVideo"
                    type="secondary"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 17"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.99891 3.16659C6.58488 3.16692 5.22883 3.72878 4.22893 4.72868C3.22873 5.72888 2.66683 7.08543 2.66683 8.49992C2.66683 8.86811 2.36835 9.16659 2.00016 9.16659C1.63197 9.16659 1.3335 8.86811 1.3335 8.49992C1.3335 6.73181 2.03587 5.03612 3.28612 3.78587C4.53636 2.53563 6.23205 1.83325 8.00016 1.83325H8.00267C9.85207 1.84021 11.6272 2.56185 12.9569 3.84727L12.9649 3.85518L14.4716 5.36185C14.7319 5.6222 14.7319 6.04431 14.4716 6.30466C14.2112 6.56501 13.7891 6.56501 13.5288 6.30466L12.0262 4.80208C10.9446 3.75848 9.50196 3.17256 7.99891 3.16659Z"
                        fill="#1530EA"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.0002 1.83325C14.3684 1.83325 14.6668 2.13173 14.6668 2.49992V5.83325C14.6668 6.20144 14.3684 6.49992 14.0002 6.49992H10.6668C10.2986 6.49992 10.0002 6.20144 10.0002 5.83325C10.0002 5.46506 10.2986 5.16659 10.6668 5.16659H13.3335V2.49992C13.3335 2.13173 13.632 1.83325 14.0002 1.83325Z"
                        fill="#1530EA"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.0002 7.83325C14.3684 7.83325 14.6668 8.13173 14.6668 8.49992C14.6668 10.268 13.9644 11.9637 12.7142 13.214C11.464 14.4642 9.76827 15.1666 8.00016 15.1666L7.99765 15.1666C6.14825 15.1596 4.37314 14.438 3.04347 13.1526L3.03543 13.1447L1.52876 11.638C1.26841 11.3776 1.26841 10.9555 1.52876 10.6952C1.78911 10.4348 2.21122 10.4348 2.47157 10.6952L3.97413 12.1977C5.0557 13.2414 6.4984 13.8273 8.00148 13.8333C9.41549 13.8329 10.7715 13.271 11.7714 12.2712C12.7716 11.271 13.3335 9.91441 13.3335 8.49992C13.3335 8.13173 13.632 7.83325 14.0002 7.83325Z"
                        fill="#1530EA"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.3335 11.1666C1.3335 10.7984 1.63197 10.4999 2.00016 10.4999H5.3335C5.70169 10.4999 6.00016 10.7984 6.00016 11.1666C6.00016 11.5348 5.70169 11.8333 5.3335 11.8333H2.66683V14.4999C2.66683 14.8681 2.36835 15.1666 2.00016 15.1666C1.63197 15.1666 1.3335 14.8681 1.3335 14.4999V11.1666Z"
                        fill="#1530EA"
                      />
                    </svg>
                  </base-btn>
                </template>
                <span
                  class="body-bold-smaller"
                  v-html="
                    $t(
                      'message.pages.videoPage.details.alert.converting.convertAgain'
                    )
                  "
                ></span>
              </v-tooltip>
            </v-row>
          </v-col>
        </v-col>
      </v-card>
      <v-col cols="12" class="mt-4 mb-4">
        <v-divider />
      </v-col>

      <v-card flat>
        <v-col cols="12" class="pt-1 py-0">
          <span class="body-bold-medium" style="vertical-align: middle">
            {{ $t('message.pages.video.unavailables') }}
          </span>
        </v-col>
        <v-col cols="12" class="py-0">
          <span class="body-regular-smaller textType6--text pageDescription">
            {{ $t('message.pages.video.unavailableExplain') }}
            <a
              target="_blank"
              type="secondary"
              :href="$t('message.pages.video.unavailableExplainUrl')"
            >
              <span>
                {{ $t('message.pages.video.learnMore') }}
              </span>
              <v-icon size="12">mdi-open-in-new</v-icon>
            </a>
          </span>
        </v-col>

        <v-col
          cols="12"
          v-for="(item, index) in extraResolutions"
          :key="`${item}--${index}`"
          class="mt-1 mb-1"
        >
          <v-col>
            <v-row
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
              class="d-flex"
            >
              <div style="display: grid">
                <span
                  class="body-regular-medium neutral-20-dark--text"
                  style="font-size: 14px"
                  >{{ item }}</span
                >
              </div>

              <v-tag type="neutral" style="display: flex; margin-left: auto"
                >{{ $t('message.pages.video.unavailable') }}
              </v-tag>
            </v-row>
          </v-col>
        </v-col>
      </v-card>

      <v-col cols="12" class="mt-4 mb-4">
        <v-divider />
      </v-col>

      <v-card flat>
        <v-col cols="12" class="pt-1 py-0">
          <span class="body-bold-medium" style="vertical-align: middle">
            {{ $t('message.pages.video.others') }}
          </span>
        </v-col>

        <v-col cols="12" class="mt-2 mb-2">
          <v-col>
            <v-row
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
              class="d-flex"
            >
              <div style="display: grid">
                <span class="body-regular-small neutral-20-dark--text"
                  >{{ $t('message.pages.video.originalBackup') }}
                </span>
                <span class="body-regular-smaller neutral-40-light--text"
                  >{{
                    addDecimal(
                      calcMegabytes(
                        storageSizeDetails['backup'] > 0
                          ? storageSizeDetails['backup']
                          : videoData.backup_size,
                        'B',
                        'MB',
                        true
                      )
                    )
                  }}
                </span>
              </div>
              <v-tooltip v-if="!isSubscriptionEnabledToDownload || !hasEditVideoPerm" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <base-btn
                      @click="downloadVideo"
                      disabled
                      style="cursor: pointer"
                      type="neutral"
                      icon
                    >
                      <v-progress-circular
                        v-if="loadings.downloadBackup"
                        indeterminate
                        color="primary"
                        size="16"
                      />
                      <simple-svg
                        v-else
                        :src="require('@/assets/pandaIcons/download.svg')"
                        width="16px"
                        height="16px"
                        :fill="
                          isSubscriptionEnabledToDownload
                            ? '#666D99'
                            : '#ABADBA'
                        "
                      />
                    </base-btn>
                  </span>
                </template>
                <span>{{
                  $t('message.downloadVideoModal.disabledDownload')
                }}</span>
              </v-tooltip>
              <base-btn
                v-else
                @click="downloadVideo"
                style="cursor: pointer"
                type="neutral"
                icon
              >
                <v-progress-circular
                  v-if="loadings.downloadBackup"
                  indeterminate
                  color="primary"
                  size="16"
                />
                <simple-svg
                  v-else
                  :src="require('@/assets/pandaIcons/download.svg')"
                  width="16px"
                  height="16px"
                  :fill="
                    isSubscriptionEnabledToDownload ? '#666D99' : '#ABADBA'
                  "
                />
              </base-btn>
            </v-row>
          </v-col>
        </v-col>

        <v-col cols="12" class="mt-1 mb-1">
          <v-col>
            <v-row
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
              class="d-flex"
            >
              <div style="display: grid">
                <span class="body-regular-small neutral-20-dark--text"
                  >{{ $t('message.pages.video.image') }}
                </span>
                <span class="body-regular-smaller neutral-40-light--text"
                  >{{
                    addDecimal(
                      calcMegabytes(
                        storageSizeDetails['images'],
                        'B',
                        'MB',
                        true
                      )
                    )
                  }}
                </span>
              </div>
            </v-row>
          </v-col>
        </v-col>
        
        <v-col
          cols="12"
          v-for="audio in lipsyncAudios"
          :key="audio.id"
          class="mt-1 mb-1"
        >
          <v-row class="d-flex align-center justify-space-between px-3 py-2">
            <div class="d-flex flex-column">
              <span class="body-regular-small neutral-20-dark--text">
                {{ getLangLabelBySrclang(audio.lang) }}
              </span>
              <span
                class="body-regular-smaller neutral-40-light--text"
              >
                {{ formatFileSize(lipsyncSizes[audio.video_id] || audio.size) }}
              </span>
            </div>

            <div class="d-flex align-center" style="gap: 8px">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-tag
                    type="neutral"
                    size="small"
                    class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span class="body-regular-smaller neutral-40-light--text">
                      {{ $t('message.ai.dubbings.dubbingLipSync') }}
                    </span>
                  </v-tag>
                </template>
                <span style="white-space: pre-line;">
                  {{ $t('message.ai.dubbings.dubbingLipSyncTooltip') }}
                </span>
              </v-tooltip>

              <MenuItemDownload
                :video="video"
                :video-id="videoId"
                :fetch-on-mount="false"
                :timeout="1000"
                :downloadLoadingStatus="downloadLoadingStatus"
                :preDownloadWarning="false"
                @submitVideoDownload="(url) => downloadVideoSubmit(url)"
              >
                <template v-slot:custom-content="{ handleDownload, loading }">
                  <base-btn
                    type="neutral"
                    icon
                    @click="handleDownload"
                    :disabled="loading"
                  >
                    <div style="width: 16px; height: 16px;">
                      <v-progress-circular
                        v-if="loading"
                        indeterminate
                        color="primary"
                        size="16"
                        class="mb-2"
                      />
                      <simple-svg
                        v-else
                        :src="require('@/assets/pandaIcons/download.svg')"
                        width="16px"
                        height="16px"
                      />
                    </div>
                  </base-btn>
                </template>
              </MenuItemDownload>
            </div>
          </v-row>
        </v-col>
      </v-card>

      <v-row no-gutters>
        <v-col
          cols="12"
          v-if="
            video.status === 'CONVERTED' &&
            (errors.testingTs || errors.testingM3u8)
          "
        >
          <v-btn
            color="primary"
            @click="handleReencodeVideo"
            :loading="loadings.reencode"
            :disabled="loadings.reencode"
            style="float: right; margin-bottom: 20px"
          >
            {{ $t('message.pages.qualitySettings.reencode') }}
          </v-btn>
        </v-col>
        <v-col cols="12" class="px-0 pt-1" v-if="errorsArray.length > 0">
          <v-alert type="error">
            <span>
              {{ $t('message.problemsWith') }}
            </span>
            <span v-for="(error, index) in errorsArray" :key="`${error.name}_`">
              <span v-if="index !== errorsArray.length - 1">
                {{ error.name }},
              </span>
              <span v-else> {{ error.name }}. </span>
            </span>
            <template slot="append">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon @click="handleShowLink()" v-bind="attrs" v-on="on"
                    >mdi-content-copy</v-icon
                  >
                </template>
                <span v-if="isCopied">
                  {{ $t('message.pages.videoEditModal.copied') }}
                </span>
                <span v-else>
                  {{ $t('message.pages.videoEditModal.copyToClipboard') }}
                </span>
              </v-tooltip>
            </template>
          </v-alert>
        </v-col>
      </v-row>
    </v-col>
    <v-dialog v-model="showModal" width="550px">
      <v-card>
        <v-toolbar class="ml-3 mt-2 mb-4" elevation="0">
          <v-toolbar-title
            class="text--subtitle mt-4"
            flat
            style="display: grid"
          >
            {{
              qualityToBeEnabled
                ? $t('message.pages.qualitySettings.enableX', {
                    quality: qualityToBeEnabled,
                  })
                : $t('message.pages.qualitySettings.disableX', {
                    quality: qualityToBeDisabled,
                  })
            }}
            <span
              class="body-regular-smaller textType6--text pageDescription mt-1"
            >
              {{ $t('message.pages.qualitySettings.knowMoreBandUsage') }}
              <a
                target="_blank"
                type="secondary"
                :href="$t('message.pages.qualitySettings.outArticleUrl')"
              >
                <span>
                  {{ $t('message.pages.qualitySettings.outArticle') }}
                </span>
                <v-icon size="12">mdi-open-in-new</v-icon>
              </a>
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <base-btn
            icon
            @click="showModal = false"
            class="closeBtn"
            type="neutral"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 16px;
              padding: 0 !important;
              width: 30px !important;
              height: 30px !important;
            "
          >
            <v-icon>mdi-close</v-icon>
          </base-btn>
        </v-toolbar>

        <v-card-text class="pl-7 pr-5 py-0 mt-2">
          <v-container class="pl-0">
            <v-row no-gutters>
              <v-col cols="12">
                <span v-if="qualityToBeEnabled" style="display: grid">
                  <span>
                    {{ $t('message.pages.qualitySettings.enablingMessage') }}
                  </span>
                  <span>
                    {{
                      $t('message.pages.qualitySettings.enablingMessage2', {
                        quality: qualityToBeEnabled,
                      })
                    }}
                  </span>
                </span>
                <span v-else-if="qualityToBeDisabled" style="display: grid">
                  <span>
                    {{ $t('message.pages.qualitySettings.disablingMessage') }}
                  </span>
                  <span>
                    {{
                      $t('message.pages.qualitySettings.disablingMessage2', {
                        quality: qualityToBeDisabled,
                      })
                    }}
                  </span>
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider style="width: 100%" />
        <v-card-actions class="px-8 pb-6 mt-3" v-if="hasEditVideoPerm">
          <v-spacer></v-spacer>
          <base-btn
            type="tertiary"
            class="mr-4 px-4"
            @click="showModal = false"
          >
            {{ $t('message.cancel') }}
          </base-btn>
          <base-btn
            v-if="qualityToBeEnabled"
            class="white--text brand-60-base-light"
            min-width="185px"
            @click="handleActiveQuality"
            :loading="loadings.handlingQuality"
          >
            {{
              $t('message.pages.qualitySettings.enableX', {
                quality: qualityToBeEnabled,
              })
            }}
          </base-btn>
          <base-btn
            v-else-if="qualityToBeDisabled"
            type="danger"
            min-width="185px"
            @click="handleDeActiveQuality"
            :loading="loadings.handlingQuality"
          >
            {{
              $t('message.pages.qualitySettings.disableX', {
                quality: qualityToBeDisabled,
              })
            }}
          </base-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <warning-download-modal
      :openWarningDownload="openWarningDownload"
    ></warning-download-modal>
  </v-card>
</template>

<script>
// external imports
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import * as m3u8Parser from 'm3u8-parser'
import axios from 'axios'
import _ from 'lodash'

// internal imports
import downloadUrlMixin from '@/utils/downloadUrl.mixin.js'
import calcMegabytesMixin from '@/utils/calcMegabytes'
import langCodes from '@/utils/langCodes.mixin'
import aiWorkflowMixin from '@/utils/aiWorkflow.mixin'
import i18n from '@/translations/lang'
import { BACKUP_DOWNLOADER_SERVER, ENV_CONFIG } from '@/config/envs'
import Storage from '@/utils/Storage'
import store from '@/store'
import WarningDownloadModal from '@/components/WarningDownloadModal.vue'
// API
import videosApi from '@/services/videosApi'

// Components
import QualityStatus from '../info/QualityStatus.vue'
import BaseBtn from '../../../components/BaseBtn.vue'
import MenuItemDownload from '@/components/MenuItemDownload.vue'

export default {
  name: 'VideoPlayerQuality',
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    customVideoId: {
      required: false,
    },
  },
  components: {
    WarningDownloadModal,
    QualityStatus,
    BaseBtn,
    MenuItemDownload,
  },
  mixins: [calcMegabytesMixin, downloadUrlMixin, langCodes, aiWorkflowMixin],
  data: function () {
    return {
      getStatusVideoTimeout: undefined,
      qualityToBeEnabled: '',
      qualityToBeDisabled: '',
      showModal: false,
      arrayFormatsAll: [],
      availableResolutionsShortened: [],
      openWarningDownload: false,
      videoSizes: ['240p', '360p', '480p', '720p', '1080p', '1440p', '2160p'],
      isCopied: false,
      loadings: {
        fetch: true,
        handlingQuality: false,
        reencode: false,
        disableQuality: false,
        startQuality: false,
        download: false,
        downloadBackup: false,
      },
      errors: {
        fetchError: false,
        shownErrMsg: i18n.t(
          'message.pages.qualitySettings.errors.defaultError'
        ),
        errMsg: '',
        testingM3u8: false,
        testingTs: false,
      },
      videoId: '',
      profileId: null,
      sizes: [],
      qualityWithErrors: [],
      testingM3u8: true,
      interval: {},
      progressTs: 0,
      progressSize: 100,
      initQuality: '',
      arrayFormats: [],
      extraInfo: [],
      storageSizeDetails: {},
      playback: [],
      m3u8HealthBackup: [],
      firstInitQuality: '',
      isConverting: false,
      downloadServer: undefined,
      authToken: '',
      qualityToBeDownloaded: '',
      videoData: {},
      downloadAudioItems: {},
      lipsyncSizes: {},
      downloadLoadingStatus: false,
      customDownloadUrl: '',
    }
  },
  async mounted() {
    await this.fetchLipsyncSizes()
    this.authToken = Storage.getItem('accessToken')
    this.videoId = this.customVideoId
      ? this.customVideoId
      : this.$route.params.id
    this.profileId = this.video.config?.profile
    this.initQuality = this.profile.saveProgress?.initQuality
      ? this.profile.saveProgress?.initQuality
      : ''
    if (this.video.status === 'CONVERTING' || this.video.status === 'DRAFT') {
      this.handleVideoQualitiesConverting()
    } else {
      this.handleVideoQualities()
    }
    this.$root.$on('closeWarningDownload', () => {
      this.openWarningDownload = false
    })
  },
  methods: {
    ...mapActions('video', [
      'updateProfile',
      'createProfile',
      'setProfileToVideos',
    ]),
    ...mapMutations('video', [
      'UPDATE_VIDEO_PROFILE',
      'UPDATE_VIDEO_PROFILE_ID',
      'UPDATE_STATUS_ERROR',
      'UPDATE_VIDEO',
    ]),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    getStandardResolutionValue(value) {
      if (!~value.indexOf('p')) {
        const [value_1, value_2] = value.split('x')
        const [width, height] = [Number(value_1), Number(value_2)]

        return Math.min(width, height)
      }
      return value.slice(0, -1)
    },
    formatDateFromBr(dateString) {
      if (!dateString) return null
      const [day, month, year] = dateString.split('/')
      return new Date(Date.UTC(year, month - 1, day))
    },
    formatFileSize(sizeInBytes) {
      if (!sizeInBytes || isNaN(sizeInBytes)) return '0 MB'
      const mb = sizeInBytes / (1024 * 1024)
      return `${mb.toFixed(1)} MB`
    },
    async fetchLipsyncSizes() {
      const lipsyncInfo = this.video?.config?.lipsync_info || []
      const validLipsyncInfo = lipsyncInfo.filter(item => !item.original && item.video_id)

      for (const lipsync of validLipsyncInfo) {
        try {
          const { data } = await videosApi.getAVideo(lipsync.video_id)
          this.$set(this.lipsyncSizes, lipsync.video_id, data.storage_size)
        } catch (e) {
          this.$set(this.lipsyncSizes, lipsync.video_id, null)
        }
      }
    },
    async downloadVideo() {
      if (
        !localStorage.getItem(`isUnderstandDownload-${this.userInfo.sub}`) &&
        localStorage.getItem(`countDownload-${this.userInfo.sub}`) &&
        Number(localStorage.getItem(`countDownload-${this.userInfo.sub}`)) >= 4
      ) {
        return (this.openWarningDownload = true)
      }
      this.loadings.downloadBackup = true
      this.qualityToBeDownloaded = null

      this.setCountDownload('backup')
      let downloadServer = Storage.getItem('downloaderServer')
      if (downloadServer) {
        this.downloadServer = downloadServer
      } else {
        this.downloadServer = BACKUP_DOWNLOADER_SERVER
      }
      const session = await store().dispatch('session/refreshSession')
      const token = session.accessToken.jwtToken
      this.authToken = token
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.pages.qualitySettings.initiateDownload'),
      })
      this.loadings.downloadBackup = false
      setTimeout(() => {
        this.$refs.downloadForm.submit()
      }, 1000)
    },
    async handleDownloadQuality({ name }) {
      if (
        !localStorage.getItem(`isUnderstandDownload-${this.userInfo.sub}`) &&
        localStorage.getItem(`countDownload-${this.userInfo.sub}`) &&
        Number(localStorage.getItem(`countDownload-${this.userInfo.sub}`)) >= 4
      ) {
        return (this.openWarningDownload = true)
      }
      this.loadings.download = true
      this.customDownloadUrl = ''
      const qualityToBeDownloaded = name.slice(0, -1)
      const qualitiesFullName = Object.keys(this.storageSizeDetails)
      const qualityToBeDownloadedFullName = qualitiesFullName.filter(
        (quality) => {
          if (quality.indexOf(qualityToBeDownloaded) !== -1) {
            return true
          }
        }
      )[0]
      this.qualityToBeDownloaded = qualityToBeDownloadedFullName
      this.setCountDownload(qualityToBeDownloadedFullName)
      let downloadServer = Storage.getItem('downloaderServer')
      if (downloadServer) {
        this.downloadServer = downloadServer
      } else {
        this.downloadServer = BACKUP_DOWNLOADER_SERVER
      }
      const session = await store().dispatch('session/refreshSession')
      const token = session.accessToken.jwtToken
      this.authToken = token
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.pages.qualitySettings.initiateDownload'),
      })
      setTimeout(() => {
        this.$refs.downloadForm.submit()
      }, 1000)
      this.loadings.download = false
    },
    downloadVideoSubmit(url) {
      this.downloadLoadingStatus = true
      this.customDownloadUrl = url
      this.$nextTick(() => this.$refs.downloadForm.submit())
      setTimeout(() => {
        this.downloadLoadingStatus = false
      }, 3000)
    },
    async downloadAudio(audio) {
      this.$set(this.downloadAudioItems, audio.id, { loading: true })
      
      let downloadServer = Storage.getItem('downloaderServer')
      if (!downloadServer) {
        downloadServer = BACKUP_DOWNLOADER_SERVER
      }
      
      let subdomain = `download-${downloadServer}`
      let port = '7443'
      let path = 'download'
      
      if (ENV_CONFIG !== 'production') {
        subdomain = `download-staging-${downloadServer}`
        port = '7442'
      }
      
      if (audio.id) {
        path = `${audio.id}/download`
      }
      
      let downloadLink = `https://${subdomain}.pandavideo.com:${port}/audios/${path}`
      this.authToken = Storage.getItem('accessToken')
      
      try {
        let data = await fetch(downloadLink, {
          headers: {
            Authorization: `Bearer ${this.authToken}`,
          },
        }).then((res) => (data = res))
        
        let blob = await data.blob()
        let url = URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        a.download = `${this.video.title}-${audio.lang}.mp3`
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
        
        this.$set(this.downloadAudioItems, audio.id, { loading: false })
      } catch (error) {
        console.error(error)
        this.$set(this.downloadAudioItems, audio.id, { loading: false, error: true })
      }
    },
    async handleVideoQualities(hotReload = false) {
      this.errors.fetchError = false
      this.isConverting = false
      await this.handleHealthCheckM3u8()
      await this.fetchData(hotReload)
      this.checkIfTheActiveQualityWasDisabled()
      await this.checkHealthy()
    },
    async handleVideoQualitiesConverting(hotReload = false) {
      this.isConverting = true
      await this.fetchData(hotReload)
      this.checkIfTheActiveQualityWasDisabled()
      await this.getStatusVideo()
    },
    handleActiveTheHighestQuality() {
      let mappedPlaylist = this.playback.map((val) => Number(val.slice(0, -1)))
      let maxQuality = Math.max(...mappedPlaylist)
      let maxQualityIndex = mappedPlaylist.indexOf(maxQuality)
      this.firstInitQuality = this.initQuality
      this.initQuality = this.playback[maxQualityIndex]
      this.handleInitialQuality(false)
    },
    async checkIfTheActiveQualityWasDisabled() {
      let initQuality = String(this.initQuality)
      if (initQuality.indexOf('p') === -1) initQuality += 'p'

      let index = this.playback.indexOf(`${initQuality}`)

      if (index === -1) {
        this.handleActiveTheHighestQuality()
      } else {
        this.initQuality = this.playback[index]
        this.firstInitQuality = this.initQuality
      }
    },
    async handleActiveQuality() {
      try {
        this.loadings.handlingQuality = true
        let playbacks = Array.from(this.playback)
        playbacks.push(this.qualityToBeEnabled)

        await videosApi.updateVideoPlayback(this.videoId, playbacks)
        await this.updateList()
        this.sizes.map(
          function (val, i) {
            val.statusM3u8 = this.m3u8HealthBackup[i].statusM3u8
            val.statusTs = this.m3u8HealthBackup[i].statusTs
            return val
          }.bind(this)
        )
        await this.checkIfTheActiveQualityWasDisabled()
        this.showModal = false
        this.loadings.handlingQuality = false
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t('message.pages.qualitySettings.enableQualitySucess', {
            quality: this.qualityToBeEnabled,
          }),
          type: 'success',
        })
      } catch (err) {
        this.loadings.handlingQuality = false
        console.error(err)
      }
    },
    async handleDeActiveQuality() {
      if (this.playback.length <= 1) {
        this.handleShowDisabledLimit()
        this.showModal = false
        return
      }
      try {
        this.loadings.handlingQuality = true
        let playbacks = Array.from(this.playback)
        let index = playbacks.indexOf(this.qualityToBeDisabled)
        playbacks.splice(index, 1)

        await videosApi.updateVideoPlayback(this.videoId, playbacks)
        await this.updateList()
        this.sizes.map(
          function (val, i) {
            val.statusM3u8 = this.m3u8HealthBackup[i].statusM3u8
            val.statusTs = this.m3u8HealthBackup[i].statusTs
            return val
          }.bind(this)
        )
        await this.checkIfTheActiveQualityWasDisabled()
        this.showModal = false
        this.loadings.handlingQuality = false
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t('message.pages.qualitySettings.disableQualitySucess', {
            quality: this.qualityToBeDisabled,
          }),
          type: 'success',
        })
      } catch (err) {
        console.error(err)
        this.loadings.handlingQuality = false
      }
    },
    handleShowModal(quality, toBeDisabled = false) {
      if (toBeDisabled) {
        this.qualityToBeDisabled = quality
        this.qualityToBeEnabled = ''
      } else {
        this.qualityToBeEnabled = quality
        this.qualityToBeDisabled = ''
      }

      this.showModal = true
    },
    handleShowLink() {
      this.isCopied = true
      navigator.clipboard.writeText(
        `${JSON.stringify(this.errorsArray)}, ${JSON.stringify({
          videoId: this.videoId,
        })}`
      )
      setTimeout(() => {
        this.isCopied = false
      }, 3000)
    },
    handleShowReencode() {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.reencoded'),
      })
    },
    handleShowDisabledLimit() {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t(
          'message.pages.qualitySettings.disablingAllQualitiesMessage'
        ),
      })
    },
    async fetchData(hotReload = false) {
      if (hotReload === true) {
        await this.updateList()
      } else {
        this.loadings.fetch = true
        await this.updateList()
        this.loadings.fetch = false
      }
    },
    async updateList() {
      try {
        const response = await videosApi.getVideoStorageSize(
          this.customVideoId ? this.customVideoId : this.$route.params.id
        )
        if (!response.data.storage_size_details) {
          this.errors.fetchError = true
          this.errors.shownErrMsg = i18n.t(
            'message.pages.qualitySettings.errors.qualitiesErrorFetch'
          )
          return
        }
        this.storageSizeDetails = response.data.storage_size_details
        const totalStorageSize = response.data.storage_size
        this.videoData = response.data

        let availableResolutionsShortened = []
        let numberResolutions = []

        let sizes = Object.keys(this.storageSizeDetails).map((item) => {
          let name
          if (!~item.indexOf('x')) {
            name = item[0].toUpperCase() + item.slice(1)
            availableResolutionsShortened.push(name)
          } else {
            name = this.getStandardResolutionValue(item)
            numberResolutions.push(Number(name))
            name = name + 'p'
            availableResolutionsShortened.push(name)
          }

          return {
            name,
            value: this.storageSizeDetails[item],
          }
        })

        this.availableResolutionsShortened = availableResolutionsShortened

        this.playback = response.data.playback.filter((playbackQuality) => {
          let indexOfAvailable =
            availableResolutionsShortened.indexOf(playbackQuality)
          if (indexOfAvailable !== -1) return playbackQuality
        })

        sizes.push({
          name: 'Total',
          value: totalStorageSize,
        })
        sizes = sizes.sort((a, b) =>
          Number(a.name.replace('p', '')) < Number(b.name.replace('p', ''))
            ? 1
            : -1
        )
        sizes = sizes.reverse()
        let extraInfo = []

        sizes = sizes.filter((obj) => {
          if (
            obj.name !== 'Total' &&
            obj.name !== 'Backup' &&
            obj.name !== 'Images'
          ) {
            return obj
          }
          extraInfo.push(obj)
          return false
        })

        extraInfo.sort((a, b) => {
          if ('Total' === a.name) return 1
          if ('Total' === b.name) return -1

          return 0
        })

        this.extraInfo = extraInfo

        sizes = sizes.map((size) => {
          if (this.playback.indexOf(size.name) === -1) {
            size.disabled = true
          }
          return size
        })
        if (this.sizes.length) {
          this.sizes = this.sizes.map((size, index) => {
            const updateObject = sizes[index]
            updateObject.progressTs = size.progressTs
            updateObject.statusTs = size.statusTs
            updateObject.statusM3u8 = size?.statusM3u8
            return updateObject
          })
        } else {
          this.sizes = sizes
        }
        this.errors.fetchError = false
      } catch (err) {
        console.log(err)
        this.errors.fetchError = true
      }
    },
    async handleReencodeVideo() {
      try {
        this.loadings.reencode = true
        await videosApi.reencodeVideo(this.videoId)
        await this.getStatusVideo()
        this.handleVideoQualitiesConverting(true)
        this.handleShowReencode()
        this.video.status = 'CONVERTING'
        this.loadings.reencode = false
      } catch (error) {
        console.log(error)
      }
    },
    handleFetchError(err) {
      let errString = ''
      if (
        err?.response?.data &&
        err?.response?.data?.errMsg &&
        err?.response?.data?.errCode
      ) {
        errString =
          err.response.data.errCode + ' ' + err.response.data.errMsg.error
      }
      this.errors.fetchError = true
      this.errors.errMsg =
        err.msg ?? errString ?? err.response.data.message ?? 'Error'
      if (err?.response?.data?.detail?.raw?.message) {
        this.errors.errMsg = err.response.data.detail.raw.message.errMsg
      }
    },
    clearSizes() {
      const mustBeRemoved = ['statusTs', 'statusM3u8', 'progressTs']
      this.sizes.map((val) => {
        let finalValue = val
        mustBeRemoved.forEach((key) => {
          if (finalValue.hasOwnProperty(key)) {
            delete finalValue[key]
          }
        })
      })
    },
    setCountDownload() {
      const currentCount =
        Number(localStorage.getItem(`countDownload-${this.userInfo.sub}`)) || 0
      if (currentCount < 5) {
        localStorage.setItem(
          `countDownload-${this.userInfo.sub}`,
          currentCount + 1
        )
      }
    },
    async getStatusVideo() {
      let video = ''
      if (document.visibilityState && document.visibilityState != 'visible') {
        return
      }
      if (this.getStatusVideoTimeout === undefined) {
        this.getStatusVideoTimeout = setInterval(async () => {
          video = await videosApi.getAVideo(this.videoId)
          if (
            video.data.status === 'DRAFT' ||
            video.data.status === 'CONVERTING'
          ) {
            this.UPDATE_VIDEO(video.data)
          } else {
            clearInterval(this.getStatusVideoTimeout)
            this.getStatusVideoTimeout = undefined
            this.clearSizes()
            this.$root.$emit('updateVideoInfo', video.data)
            this.UPDATE_VIDEO(video.data)
            this.handleVideoQualities(true)
          }
        }, 5000)
      }
    },
    isStaging() {
      return !!window.location.host.match(/stg.dashboard|localhost/)
    },
    checkIfIsImport(video) {
      if (!video.description) return
      const desc = video.description
      let val = desc.includes('hotmart') || desc.includes('vimeo')
      return val
    },
    async handleInitialQuality(showSnackbar = true) {
      if (this.initQuality === this.firstInitQuality) {
        if (showSnackbar) {
          this.handleSnackbar()
        }
        return
      }

      let initialQuality = ''
      if (this.initQuality) {
        this.firstInitQuality = this.initQuality
        initialQuality = parseInt(this.initQuality.slice(0, -1))
      }

      const { saveProgress } = this.$store.state.video.profile
      const saveProgressData = {
        ...saveProgress,
        initQuality: initialQuality,
        saveProgressBackgroundOpacityFormated:
          saveProgress.saveProgressBackgroundOpacity,
      }

      if (!this.video.config.profile) {
        await this.createProfile(this.videoId)
        this.video.config.profile = this.profile_id
        this.profileId = this.profile_id
        await this.setProfileToVideos([this.profileId, this.videoId])
      }
      const { controls, colors } = this.$store.state.video.profile
      try {
        await this.updateProfile([
          this.profileId,
          {
            colors,
            controls,
            saveProgress: saveProgressData,
          },
        ])
        if (showSnackbar && !this.internalError) {
          this.handleSnackbar()
        }
      } catch (e) {
        console.error(e)
      }
      this.$root.$emit('updateEmbedPreviewChange')
    },
    async handleHealthCheckM3u8() {
      const endpointAll = `https://b-${this.video.pullzone_name}.tv.pandavideo.com.br/${this.video.video_external_id}/playlist.m3u8?all=1`
      const endpoint = `https://b-${this.video.pullzone_name}.tv.pandavideo.com.br/${this.video.video_external_id}/playlist.m3u8`
      try {
        const retAll = await axios.get(endpointAll)
        const ret = await axios.get(endpoint)
        let manifestAll = retAll.data
        let manifest = ret.data
        let parser = new m3u8Parser.Parser()
        let parserAll = new m3u8Parser.Parser()
        parser.push(manifest)
        parser.end()
        parserAll.push(manifestAll)
        parserAll.end()
        let parsedManifestAll = parserAll.manifest.playlists
        let parsedManifest = parser.manifest.playlists
        const arrayFormats = parsedManifest.map((item) => {
          return this.getManifestQuality(item)
        })
        const arrayFormatsAll = parsedManifestAll.map((item) => {
          return this.getManifestQuality(item)
        })
        this.arrayFormatsAll = arrayFormatsAll
        this.arrayFormats = arrayFormats
      } catch (error) {
        this.handleFetchError(error)
      }
    },
    getManifestQuality(item) {
      return `${item.attributes.RESOLUTION.width}x${item.attributes.RESOLUTION.height}`
    },
    async checkHealthy() {
      try {
        await this.handleCheckAllFormatsM3u8(this.sizes)
      } catch (err) {
        console.error(err)
      }
    },
    async handleCheckAllFormatsM3u8(formats) {
      if (
        this.video.status === 'CONVERTING' ||
        this.video.status === 'DRAFT' ||
        (this.video.drm_group_ids &&
          this.video.drm_group_ids.some((row) => row.active))
      )
        return
      for (const format of formats) {
        let ret = null
        const isStaging = this.isStaging() ? '.stg' : ''
        const baseUrl = `https://b-${this.video.pullzone_name}${isStaging}.tv.pandavideo.com.br/${this.video.video_external_id}`

        try {
          ret = await axios.get(`${baseUrl}/${format.name}/video.m3u8`)
        } catch (error) {
          try {
            const sizeMap = {
              '240p': '426x240',
              '360p': '640x360',
              '480p': '842x480',
              '720p': '1280x720',
              '1080p': '1920x1080',
              '1440p': '2560x1440',
              '2160p': '3840x2160',
            }
            const size = sizeMap[format.name] || format.name
            ret = await axios.get(`${baseUrl}/${size}/video.m3u8`)
          } catch (err) {
            console.error(`Erro nas duas tentativas para ${format.name}`, err)
          }
        }

        if (!ret || ret.status !== 200) {
          this.qualityWithErrors.push(format.name)
        }
      }
      this.testingM3u8 = false
    },
    async handleHealthCheckTs(formats) {
      if (this.video.status === 'CONVERTING') return
      for (let i in formats) {
        const isStaging = this.isStaging() ? '.stg' : ''
        const resolution = this.getStandardResolutionValue(formats[i])
        let endpoint = `https://b-${this.video.pullzone_name}${isStaging}.tv.pandavideo.com.br/${this.video.video_external_id}/${formats[i].name}/video.m3u8`
        try {
          const ret = await axios.get(endpoint)
          console.log(ret)
          let manifest = ret.data
          let parser = new m3u8Parser.Parser()
          parser.push(manifest)
          parser.end()
          let parsedManifest = parser.manifest.segments
          const arrayUrls = parsedManifest.map((item) => {
            const resolutions = item.uri
            return resolutions
          })
          let res = await this.handleCheckAllFormatsTs(arrayUrls, resolution)
          if (res === false) break
        } catch (error) {
          this.loadMessage({}, [], resolution, true)
          console.log(error)
        }
        this.m3u8HealthBackup = this.sizes
      }
    },
    async handleCheckAllFormatsTs(arrayUrls, quality) {
      let arrayResponse = []
      let arrayContentTypes = []
      let promiseControl = 0
      for (let i in arrayUrls) {
        if (this.video.status === 'CONVERTING') break
        const item = arrayUrls[i]
        try {
          const ret = await axios.head(item)
          const status = ret.status
          arrayResponse.push(status)
          arrayContentTypes.push(ret.headers['content-type'])
          if (status === 200)
            this.verifyAndSend(arrayResponse, arrayUrls, quality)
        } catch (e) {
          arrayResponse.push(e.response.status)
        }
        if (i !== 0 && i !== arrayUrls.length - 1 && promiseControl === 40) {
          promiseControl = 0
          await this.delay(1500)
        }
        promiseControl++
      }
      if (this.video.status === 'CONVERTING') return false
      try {
        this.loadMessage(
          { arrayResponse, arrayContentTypes, finished: arrayResponse.length },
          arrayUrls,
          quality
        )
      } catch (err) {
        console.error(err)
        this.loadMessage(
          { arrayResponse, arrayContentTypes, finished: arrayResponse.length },
          arrayUrls,
          quality
        )
      }
      this.verifyAndSend(arrayResponse, arrayUrls, quality)
      return new Promise((resolve) => resolve())
    },
    addDecimal(lengthString) {
      let [numberPart, unitPart] = lengthString.split(' ')

      const numericValue = Number(numberPart)
      const formattedNumber = isNaN(numericValue) ? 0 : numericValue.toFixed(1)
      const unitLabel = unitPart || ''

      return `${formattedNumber} ${unitLabel}`.trim()
    },
    verifyAndSend(arrayResponse, arrayUrls, quality) {
      this.loadMessage(
        { finished: arrayResponse.length, type: 'progress' },
        arrayUrls,
        quality
      )
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    loadMessage(data, arrayUrls, quality, confirmedError = false) {
      if (confirmedError) {
        this.sizes = this.sizes.map((item) => {
          if (quality == item.name.slice(0, -1)) {
            this.errors.testingTs = true
            return { ...item, statusTs: 'error' }
          }
          return item
        })
        return
      }
      if (data.type === 'progress') {
        const finished = data.finished
        let total = arrayUrls.length
        let progress = (finished * 100) / total

        this.sizes = this.sizes.map((item) => {
          if (quality == item.name.slice(0, -1)) {
            return { ...item, progressTs: progress }
          }
          return item
        })
        return
      }
      const arrayStatus = _.cloneDeep(data.arrayResponse)
      const arrayContentType = _.cloneDeep(data.arrayContentTypes)
      const status = arrayStatus.every((result) => {
        return result === 200
      })
      const contentType = arrayContentType.every(
        (result) => result === 'video/mp2t'
      )
      this.sizes = this.sizes.map((item) => {
        if (quality == item.name.slice(0, -1)) {
          if (contentType && status) {
            return { ...item, statusTs: 'ok' }
          } else if (!status) {
            this.errors.testingTs = true
            return { ...item, statusTs: 'error' }
          }
        }
        return item
      })
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.pages.video.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
    qualitysWithError(quality) {
      return this.qualityWithErrors.includes(quality)
    },
    handleSelectInitQuality(qualityName) {
      this.loadings.startQuality = true
      this.initQuality = qualityName
      this.handleInitialQuality()
      this.loadings.startQuality = false
    },
  },
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
      userInfo: (state) => state.user.userInfo,
    }),
    lipsyncAudios() {
      const audios = this.video?.audios || []
      const lipsyncInfo = this.video?.config?.lipsync_info || []
      const lipsyncSizes = this.lipsyncSizes || {}

      const validLipsyncInfo = lipsyncInfo.filter(item => !item.original && item.video_id)

      const lipsyncByLang = {}
      validLipsyncInfo.forEach(item => {
        lipsyncByLang[item.srclang] = item
      })

      return audios
        .map(audio => {
          const lipsync = lipsyncByLang[audio.lang]
          if (lipsync) {
            return {
              ...audio,
              is_lipsync: true,
              label: lipsync.label || audio.label,
              video_id: lipsync.video_id,
              size: lipsyncSizes[lipsync.video_id] ?? null
            }
          }
          return audio
        })
        .filter(audio => audio.is_lipsync && audio.status === 'CONVERTED')
    },
    sizesComputed() {
      return this.sizes.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.name === item.name)
      )
    },
    ...mapGetters('user', ['hasEditVideoPerm']),
    isSubscriptionEnabledToDownload() {
      const blockDownloadStatus = ['unpaid', 'canceled']
      let isDownloadAllowed = true
      if (
        this.userPlanInfo.subscription &&
        this.userPlanInfo.subscription.metadata.trusted_download
      ) {
        const trustedDownloadDate = this.userPlanInfo.subscription_metadata
          ?.trusted_download
          ? this.formatDateFromBr(
              this.userPlanInfo.subscription_metadata.trusted_download
            )
          : null
        isDownloadAllowed =
          !trustedDownloadDate || trustedDownloadDate >= new Date()
      }
      return (
        this.userPlanInfo.subscription &&
        !blockDownloadStatus.includes(this.userPlanInfo.subscription.status) &&
        isDownloadAllowed
      )
    },
    extraResolutions() {
      let arr = []
      this.videoSizes.map(
        function (val) {
          let valIndex = this.availableResolutionsShortened.indexOf(val)
          if (valIndex === -1) arr.push(val)
        }.bind(this)
      )

      return arr
    },
    errorsArray() {
      let errorsArray = this.sizes.filter((item) => {
        if (item?.statusM3u8 === 'error' || item.statusTs === 'error') {
          return item
        }
      })

      return errorsArray
    },
    sizesList() {
      return [...this.sizes, ...this.extraResolutions]
        .sort((a, b) => {
          const _a = parseInt((a.name ?? a).replace('p', ''))
          const _b = parseInt((b.name ?? b).replace('p', ''))
          return _a - _b
        })
        .map((size) => {
          if (size.name) return { ...size, available: true }
          else return { name: size, available: false }
        })
    },
    ...mapState({
      profile: (state) => state.video.profile,
      video: (state) => state.video.video,
      profile_id: (state) => state.video.profile_id,
      internalError: (state) => state.video.internalError,
    }),
  },
}
</script>

<style scoped lang="scss">
.opacity-0 {
  opacity: 0;
}
</style>

<style lang="scss">
.list-storage-video {
  .storage-video-card {
    &:nth-last-child(1) {
      border-radius: 0;
      border-top: 1px solid #666;
      font-weight: bold;
    }
  }
}

.healthcheck-card {
  .v-progress-circular {
    width: 32px !important;
    height: 32px !important;
  }
}

.unavailable-quality {
  transform: translate(8px, 0px);
  margin-bottom: 0px !important;
  text-align: right;
  font-size: 13px;

  &-button {
    background-color: #9b9b9b;
    padding: 0px 4px;
    border-radius: 4px;
  }

  &-container * {
    color: rgb(221, 221, 221);
  }
}

.quality-button {
  background-color: #d7d7d7;
  padding: 0px 4px;
  border-radius: 4px;
}

.disabled-quality {
  *:not(.healthcheck-card *) {
    color: gray;

    .mdi-download {
      color: var(--v-primary-base);
    }
  }
}

.enabled-quality {
  background-color: #4caf50;
  color: #fff;
}

.backIcon {
  color: varFigma(brand-60-base) !important;
}

.backBtn {
  cursor: pointer;
}

.closeBtn {
  color: varFigma(neutral-70) !important;
}
</style>
